import React, { useState } from "react";
import { Switch, Form, Tooltip, message } from "antd";
import { exhibitionUseMutation } from "../hooks";
import { Localize } from "components/service";
import { localizeByKeyStatic } from "components/service/localize";
import { usePermissionByObject, useIsDeveloper } from "components/permissions";
import Exhibitions from "components/exhibition";
import { EExhibitionStatus } from "../helpers/exhibition-types-helper";

interface IExhibitionStatusFieldProps
{
    id: string;
    status: string;
    dafaultExhibition: boolean;
}

const ExhibitionStatusField: React.FC<IExhibitionStatusFieldProps> = ({ id, status, dafaultExhibition }) =>
{
    const [ form ] = Form.useForm();
    const [ statusValue, setStatusValue ] = useState(status === EExhibitionStatus.ACTIVE);

    const { _setExhibitionCreateUpdate } = exhibitionUseMutation.createUpdate(
        id,
        undefined
    );

    const { hasPermission: hasChangeStatusPermission } = usePermissionByObject(Exhibitions.Const.permissions.CHANGE_STATUS);
    const isDeveloper = useIsDeveloper();

    const validateChangeStatusPermission = () => {
        if (!isDeveloper && !hasChangeStatusPermission) {
            message.error(localizeByKeyStatic('PERMISSION.Error_AccessDenied'));
            return false;
        }
        return true;
    };

    return (
        <Form form={form} className="">
            <div className="switch-holder">
                <Form.Item
                    name="status"
                    initialValue={status === EExhibitionStatus.ACTIVE}
                    style={{ marginBottom: 0 }}
                >
                    <Tooltip
                        title={!hasChangeStatusPermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(Exhibitions.Const.permissions.CHANGE_STATUS.slug)}` : undefined}
                    >
                        <Switch
                            checked={statusValue}
                            disabled={
                                (!hasChangeStatusPermission) ||
                                (dafaultExhibition && status === EExhibitionStatus.ACTIVE)
                            }
                            onChange={(checked) => {
                                if (!validateChangeStatusPermission()) {
                                    return;
                                }

                                setStatusValue(checked);
                                _setExhibitionCreateUpdate({
                                    variables: {
                                        input: {
                                            id,
                                            status: checked ? EExhibitionStatus.ACTIVE : EExhibitionStatus.CLOSED,
                                        },
                                    },
                                });
                            }}
                        />
                    </Tooltip>
                </Form.Item>

                {statusValue ? (
                    <span
                        style={{ color: "var(--switch_colorPrimary)" }}
                        className="switch-status-text"
                    >
                        <Localize>GLOBAL.Text_Active</Localize>
                    </span>
                ) : (
                    <span
                        style={{ color: "var(--switch_colorTextQuaternary)" }}
                        className="switch-status-text"
                    >
                        <Localize>GLOBAL.Text_Blocked</Localize>
                    </span>
                )}
            </div>
        </Form>
    );
};

export default ExhibitionStatusField;